module.exports = __webpack_public_path__ + "img/jiantou.a91a2692.png";